import React from "react";
import ReactDom from "react-dom/client"
import {BrowserRouter} from "react-router-dom"
import global from "./css/global.css"
import App from "./App";

const root = document.getElementById('root')
ReactDom.createRoot(root).render(
    
    <BrowserRouter>
    <React.StrictMode>
            <App/>
    </React.StrictMode>
    </BrowserRouter>
    
)


